import React, { useEffect, useState } from "react";
import {
  Breadcrumb,
  Row,
  Col,
  Card,
  Space,
  Button,
  Modal,
  notification,
  Table,
} from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

import EditFaq from "./Edit";
import CreateFaq from "./Create";
import FaqOrdering from "./Ordering";

import http from "../../../../helpers/http";
import axios from "axios";
import config from "../../../../config/config";

import { useMediaQuery } from "react-responsive";

function Index() {
  const { confirm } = Modal;

  const [loading, setLoading] = useState(false);

  const [editOpen, setEditOpen] = useState(false);
  const [createOpen, setCreateOpen] = useState(false);
  const [isOrderOpen, setIsOrderOpen] = useState(false);

  const [data, setData] = useState({});
  const [datas, setDatas] = useState([]);
  const [editKey, setEditKey] = useState(1);
  const [createKey, setCreateKey] = useState(1);

  const isMobile = useMediaQuery({ query: "(max-width: 576px)" });
  const [btnSize, setBtnSize] = useState("middle");

  const moduleName = "FAQ Category";
  const moduleNamePlural = "FAQ Categories";

  const base_url = config.api_url + "faq";

  const handleEdit = (id) => {
    const category = datas.find((c) => c._id === id);
    if (category) {
      setEditKey((prev) => prev + 1);
      setData(category);
      setEditOpen(true);
    } else {
      notification.error({ message: "Category not found" });
    }
  };

  const handleCreate = () => setCreateOpen(true);

  const handleEditClose = () => {
    setEditKey((prev) => prev + 1);
    setData({});
    setEditOpen(false);
    fetchDatas();
  };

  const handleCreateClose = () => {
    setCreateKey((prev) => prev + 1);
    setCreateOpen(false);
    fetchDatas();
  };

  const handleOrderClose = () => {
    setIsOrderOpen(false);
    fetchDatas();
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${base_url}/delete`, {
        data: { id },
      });
      notification.success({ message: `${moduleName} Deleted Successfully` });
      fetchDatas();
    } catch (err) {
      notification.error({
        message: "Failed to delete",
        description: err.message,
      });
    }
  };

  const showDeleteConfirm = (id) => {
    confirm({
      title: `Are you sure you want to delete this ${moduleName}?`,
      icon: <ExclamationCircleOutlined />,
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        return handleDelete(id);
      },
    });
  };

  const fetchDatas = async () => {
    setLoading(true);
    try {
      const res = await axios.get(base_url);
      console.log("Axios Response:", res); // Check this
      if (res?.data) {
        setDatas(res.data);
      }
    } catch (err) {
      notification.error({
        message: "Failed to fetch FAQs",
        description: err.message,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDatas();
  }, []);

  useEffect(() => {
    if (isMobile) {
      setBtnSize("small");
    }
  }, [isMobile]);

  const columns = [
    {
      title: "Category Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Total FAQs",
      key: "faq_count",
      render: (record) => record.faqs.length,
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space>
          <Button
            type="primary"
            size={btnSize}
            onClick={() => handleEdit(record._id)}
          >
            Edit
          </Button>
          <Button
            type="danger"
            size={btnSize}
            onClick={() => showDeleteConfirm(record._id)}
          >
            Delete
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Dashboard</Breadcrumb.Item>
        <Breadcrumb.Item>{moduleNamePlural}</Breadcrumb.Item>
      </Breadcrumb>

      <Row>
        <Col span={24}>
          <Card title={moduleNamePlural} bordered={false}>
            <Row style={{ marginBottom: "20px" }}>
              <Col span={24}>
                <Space>
                  <Button type="primary" size={btnSize} onClick={handleCreate}>
                    Add {moduleName}
                  </Button>
                  <Button
                    type="primary"
                    size={btnSize}
                    onClick={() => setIsOrderOpen(true)}
                  >
                    View Ordering
                  </Button>
                </Space>
              </Col>
            </Row>

            <Table
              loading={loading}
              rowKey={(record) => record._id}
              columns={columns}
              dataSource={datas}
              footer={() => `Total ${moduleNamePlural}: ${datas.length}`}
            />

            {/* MODALS */}
            <EditFaq
              key={`edit${editKey}`}
              isVisible={editOpen}
              handleClose={handleEditClose}
              dbData={data} // category object
              faqIndex={0} // index of FAQ to edit
              base_url={base_url}
              moduleName="FAQ"
            />

            <CreateFaq
              key={`create${createKey}`}
              isVisible={createOpen}
              handleClose={handleCreateClose}
              base_url={base_url}
              moduleName={moduleName}
            />

            <FaqOrdering
              isOpen={isOrderOpen}
              onClose={handleOrderClose}
              datas={datas}
              moduleName={moduleName}
              base_url={base_url}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default Index;
